import { render, staticRenderFns } from "./Irradiation.vue?vue&type=template&id=2393ffcd&scoped=true&"
import script from "./Irradiation.vue?vue&type=script&lang=js&"
export * from "./Irradiation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2393ffcd",
  null
  
)

component.options.__file = "Irradiation.vue"
export default component.exports